import React from "react";
import styled from "@emotion/styled";

import UIcon from "../../lib/icons/untitled_ui/UIcon";
import Button from "../ui/button/Button";

type SidebarButtonProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  appliedFiltersCount?: number;
};

function SidebarButton({ open, onOpenChange, appliedFiltersCount }: SidebarButtonProps) {
  return (
    <Button buttonType="secondary" onClick={() => onOpenChange(!open)}>
      <UIcon icon="layoutLeft" color="blue500" size={16} />
      {appliedFiltersCount && appliedFiltersCount > 0 && !open && (
        <AppliedFiltersCount>{appliedFiltersCount}</AppliedFiltersCount>
      )}
    </Button>
  );
}

const AppliedFiltersCount = styled.span(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  backgroundColor: theme.colors.sysPrimaryDefault,
  width: "20px",
  padding: "0 4px",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "20px",
  color: theme.colors.sysTextWhite,
}));

export default SidebarButton;
